import React, { lazy, Suspense } from "react";
import Layout from "../../components/Layout/Layout";
import { FaSpinner } from "react-icons/fa";

const Bookingsstatus = lazy(() =>
  import("../../components/Bookingstatus/Bookingsstatus")
);

const Bookingstatus = () => {
  return (
    <div>
      <Layout>
        <Suspense
          fallback={
            <div className="flex items-center justify-center h-[500px]">
              <span className="animate-pulse flex text-xl font-medium text-[#f95552]">
                <FaSpinner className="animate-spin text-red-500 text-2xl" />
                <img src="/assets/logo.png" className="w-48 h-20" loading="lazy" />
              </span>
            </div>
          }
        >
          <Bookingsstatus />
        </Suspense>
      </Layout>
    </div>
  );
};

export default Bookingstatus;
